export default __webpack_public_path__ + "static/argent-ce2a82217ca6598a9aa4777c09c26b45.png";